export * from './TechPhoneFaxIcon';
export * from './TechPhoneFaxIcon16Light';
export * from './TechPhoneFaxIcon16Regular';
export * from './TechPhoneFaxIcon16Solid';
export * from './TechPhoneFaxIcon20Light';
export * from './TechPhoneFaxIcon20Regular';
export * from './TechPhoneFaxIcon20Solid';
export * from './TechPhoneFaxIcon24Regular';
export * from './TechPhoneFaxIcon24Solid';
export * from './TechPhoneFaxIcon32Regular';
export * from './TechPhoneFaxIcon64Regular';
